"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBasicSentence = exports.BasicSentenceSchema = exports.isSentenceType = exports.SentenceGroup = void 0;
const z = __importStar(require("zod"));
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
var SentenceGroup;
(function (SentenceGroup) {
    SentenceGroup["ExploreAndSili"] = "app";
    SentenceGroup["FrequencyList"] = "appGrammar";
    SentenceGroup["SpecialWord"] = "special";
})(SentenceGroup = exports.SentenceGroup || (exports.SentenceGroup = {}));
const DeprecatedNonBootcampSententeTypeSchema = z.union([
    z.literal("fluent_forever"),
    z.literal("user_generated"), // should be converted to "non_special"
]);
const NewNonBootcampSentenceTypeSchema = z.union([
    z.literal("non_special"),
    z.literal("special"), // currently unused, should migrate to this
]);
const NonBootcampSentenceTypeSchema = z.union([
    DeprecatedNonBootcampSententeTypeSchema,
    NewNonBootcampSentenceTypeSchema,
]);
const SentenceTypeSchema = z.union([
    NonBootcampSentenceTypeSchema,
    z.literal("bootcamp"), // currently unused, should migrate to this
]);
exports.isSentenceType = type_validation_helpers_1.getTypeValidationFunction(SentenceTypeSchema);
exports.BasicSentenceSchema = z.object({
    audio_url: z.string(),
    id: z.string(),
    is_special_word_sentence: z.boolean().optional(),
    is_ugc: z.boolean().optional(),
    known_txt: z.string(),
    learn_txt: z.string(),
    sentence_type: SentenceTypeSchema,
    vulgar: z.boolean(),
});
exports.isBasicSentence = type_validation_helpers_1.getTypeValidationFunction(exports.BasicSentenceSchema);
//# sourceMappingURL=common_sentence_types.js.map